export default __webpack_public_path__ + "static/image3-90035494d5882b48cdab52dfca330138.gif";